import { Box } from "@mui/material";
import FormHeader from "../../dms_common/FormHeader";
import { useNavigate } from "react-router-dom";
import LoadoutFiler from "../common/LoadoutFilter";
import CreateRsuLoadout from "./CreateRsuLoadout";
import { useState } from "react";
import  { Dayjs } from "dayjs";
import { VehicleOption } from "../common/types";
import { useDispatch } from "react-redux";

export default function RsuDelivery() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [selectedRsu, setSelectedRsu] = useState<string | string[]>("");
  const [selectedVehicle, setSelectedVehicle] = useState<
    VehicleOption | undefined
  >(undefined);
  const [selectedSalesrepOrRoute, setSelectedSalesrepOrRoute] = useState<
    string | string[]
  >([]);

  const dateChangeHandler = (startDate: Dayjs | null) => {
    setStartDate(startDate);
  };


  return (
    <div
      style={{ padding: "16px 15px 16px 15px" }}
      className="manage_loadout_parent"
    >
      <Box sx={{ marginTop: "6px", marginBottom: "10px" }}>
        <FormHeader
          parentLabel={"Loadouts"}
          label={"Create New Delivery"}
          childLabel={"RSU Delivery"}
          goBackToParent={() => {
            navigate("/dashboard/delivery/loadouts");
            dispatch({ type: "RESET_PRESELLER_LOADOUT" });
          }}
        />
      </Box>
      {/* <LoadoutFiler
        filters=
        deliveryStartDate={startDate}
        deliveryEndDate={startDate}
        dateChangeHandler={dateChangeHandler}
      /> */}
      {/* {loadoutConfig.displaySummary && (
        <CreateSummaryCard title="Loadout Summary" box={[]} />
      )} */}
      <CreateRsuLoadout />
    </div>
  );
}
